import { render, staticRenderFns } from "./ModalFoodguruTerm.vue?vue&type=template&id=838ee076&scoped=true&"
import script from "./ModalFoodguruTerm.vue?vue&type=script&lang=js&"
export * from "./ModalFoodguruTerm.vue?vue&type=script&lang=js&"
import style0 from "./ModalFoodguruTerm.vue?vue&type=style&index=0&id=838ee076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838ee076",
  null
  
)

export default component.exports